<template>
  <div>
    <div class="noriceInfo">
      <div class="title">
        <span>当前位置：&nbsp</span>
        <span>展会</span>
        <span>></span>
        <span>精彩视频</span>
      </div>
      <div class="content">
        <div
          class="videos"
          v-for="(item,index) in videosList.slice( (pageIndex - 1) * pageSize, pageIndex * pageSize )"
          :key="index"
          @click="detail(item.id)"
        >
          <div class="img">
            <img :src="getImageSrc(item.image)" alt />
          </div>
          <p class="_title">{{ item.title }}</p>
          <p class="seeNum">
            围观：
            <span>{{ item.click }}</span>
          </p>
        </div>
      </div>

      <el-pagination
        background
        @current-change="currentChangeHandle"
        :current-page="pageIndex"
        :page-size="pageSize"
        layout="prev, pager, next, slot"
        :total="totalPage"
      >
        <el-input type="text" v-model="pageNum"></el-input>
        <el-button class="tz" @click="pageTz">跳转</el-button>
      </el-pagination>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      pageIndex: 1,
      pageSize: 15,
      pageNum: null,
      totalPage: 0,
      videosList: [],
    };
  },
  mounted() {
    this.$http({
      url: "getWonderfulVideoList",
      method: "post",
      params: {
		status:"0"
      },
    }).then(({ data }) => {
      let { code, wonderfulVideoList } = data;
      if (code === 0) {
        this.videosList = wonderfulVideoList;
        this.totalPage = wonderfulVideoList.length;
      }
    });
  },
  methods: {
    getImageSrc(src) {
      return this.$http.adornUrl(src);
    },
    currentChangeHandle(val) {
      this.pageIndex = val;
    },
    pageTz() {
      this.pageIndex = this.pageNum;
    },
	detail(id) {
	  this.$router.push({
	    path: "/mediaCenter/videoDetails",
	    query: {
	      code: id
	    }
	  })
	},
	
  },
};
</script>
<style lang="scss">
.noriceInfo {
  .btn-prev,
  .btn-next {
    width: 52px;
    height: 32px;
    color: #eeeeee;
  }
  .el-icon-arrow-left:before {
    content: "上一页";
  }
  .el-icon-arrow-right:before {
    content: "下一页";
  }
  .el-pager {
    height: 32px;
    .active {
      background-color: #17327e !important;
    }
    .number {
      height: 100%;
      width: 32px;
      line-height: 32px;
      &:hover {
        background-color: #17327e !important;
        color: #ffffff !important;
      }
    }
  }
  .btn-quicknext {
    height: 32px;
    line-height: 32px !important;
  }
  .el-pagination {
    .el-input {
      width: 32px;
      height: 32px;
      .el-input__inner {
        border-radius: 0;
        width: 32px;
        height: 32px;
        padding: 0;
      }
    }
    .el-button {
      width: 54px;
      height: 32px;
      background-color: #eeeeee;
      color: #525252;
      margin-left: 8px;
      span {
        line-height: 32px;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.noriceInfo {
  height: 1766px;
  background-color: #ffffff;
  box-shadow: -8px 0px 8px #fafafa, 0px -8px 8px #fafafa, 0px 8px 8px #fafafa;
  margin-bottom: 45px;
  .title {
    height: 43px;
    border-bottom: 1px solid #e5e5e5;
    line-height: 43px;
    padding-left: 17px;
    color: #b6b6b6;
    font-size: 12px;
    span:nth-child(3) {
      margin: 0 11px;
    }
  }
  .content {
    height: 1580px;
    margin-bottom: 60px;
    padding-top: 10px;
    .videos {
      width: 258px;
      height: 292px;
      border: 1px solid #e6e6e6;
      color: #bbbbbb;
      float: left;
      border-radius: 5px 5px 0 0;
      margin: 20px 0 0 33px;
      cursor: pointer;
      .img {
        height: 193px;
        border-bottom: 1px solid #e6e6e6;
        border-radius: 5px 5px 0 0;
        img {
          width: 100%;
          height: 100%;
        }
      }
      p {
        width: 230px;
        padding-left: 12px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      ._title {
        color: #333333;
        font-size: 16px;
        margin: 21px 0 18px 0;
      }
      .seeNum {
        font-size: 12px;
      }
    }
  }
  .el-pagination {
    text-align: center;
  }
}
</style>